<template>
  <div class="side-menu flex-lg-column">
    <!-- LOGO -->
    <div class="navbar-brand-box">
      <router-link
        :to="{ name: 'Dashboard' }"
        class="logo"
        custom
        v-slot="{ navigate }"
      >
        <span
          role="link"
          @click="navigate"
          class="logo-sm"
          @keypress.enter="navigate"
        >
          <img
            :src="
              $store.state.config.frontpoint +
              '/storage/NewABC_logo_without-bg.png'
            "
            width="28"
            height="30"
            alt="Newabc App Logo"
          />
        </span>
      </router-link>
    </div>
    <!-- end navbar-brand-box -->

    <!-- Start side-menu nav -->
    <div class="flex-lg-column my-0 sidemenu-navigation">
      <ul class="nav nav-pills side-menu-nav" role="tablist">
        <li
          class="nav-item"
          data-bs-toggle="tooltip"
          data-bs-placement="right"
          data-bs-trigger="hover"
          data-bs-container=".sidemenu-navigation"
          title="Profile"
        >
          <router-link :to="{ name: 'Profile' }" custom v-slot="{ navigate }">
            <a
              role="link"
              @click="navigate"
              class="nav-link"
              v-bind:class="$route.name == 'Profile' ? 'active' : ''"
              id="pills-user-tab"
              @keypress.enter="navigate"
            >
              <i class="bx bx-user-circle"></i>
            </a>
          </router-link>
        </li>
        <li
          class="nav-item"
          data-bs-toggle="tooltip"
          data-bs-placement="right"
          data-bs-trigger="hover"
          data-bs-container=".sidemenu-navigation"
          title="Chats"
        >
          <router-link :to="{ name: 'Rooms' }" custom v-slot="{ navigate }">
            <a
              role="link"
              @click="navigate"
              class="nav-link"
              v-bind:class="
                $route.name == 'Rooms' || $route.name == 'Room' ? 'active' : ''
              "
              id="pills-chat-tab"
              @keypress.enter="navigate"
            >
              <i class="bx bx-conversation"></i>
            </a>
          </router-link>
        </li>

        <!-- ************ START ADMIN *********** -->
        <li
          v-if="$store.state.modules.account.user.roles == 'administrator'"
          class="nav-item"
          data-bs-toggle="tooltip"
          data-bs-placement="right"
          data-bs-trigger="hover"
          data-bs-container=".sidemenu-navigation"
          title="Contacts"
        >
          <router-link :to="{ name: 'Members' }" custom v-slot="{ navigate }">
            <a
              role="link"
              @click="navigate"
              class="nav-link"
              v-bind:class="$route.name == 'Members' ? 'active' : ''"
              id="pills-contacts-tab"
              @keypress.enter="navigate"
            >
              <i class="bx bxs-user-detail"></i>
            </a>
          </router-link>
        </li>

        <li
          class="nav-item"
          data-bs-toggle="tooltip"
          data-bs-placement="right"
          data-bs-container=".sidemenu-navigation"
          data-bs-trigger="hover"
          title="Search"
          @click="test"
        >
          <router-link :to="{ path: '/search' }" custom v-slot="{ navigate }">
            <a
              role="link"
              @click="navigate"
              class="nav-link"
              v-bind:class="$route.name == 'Search' ? 'active' : ''"
              id="pills-search-tab"
              @keypress.enter="navigate"
            >
              <i class="fa-solid fa-magnifying-glass"></i>
            </a>
          </router-link>
        </li>
        <!-- ************ END ADMIN *********** -->

        <li
          class="nav-item"
          data-bs-toggle="tooltip"
          data-bs-placement="right"
          data-bs-container=".sidemenu-navigation"
          data-bs-trigger="hover"
          title="Settings"
        >
          <router-link :to="{ path: '/setting' }" custom v-slot="{ navigate }">
            <a
              role="link"
              @click="navigate"
              class="nav-link"
              v-bind:class="$route.name == 'Setting' ? 'active' : ''"
              id="pills-setting-tab"
              @keypress.enter="navigate"
            >
              <i class="bx bx-cog"></i>
            </a>
          </router-link>
        </li>
        <li class="nav-item mt-auto" @click="initSettings">
          <a
            class="nav-link light-dark"
            href="#"
            data-bs-toggle="tooltip"
            data-bs-trigger="hover"
            data-bs-placement="right"
            data-bs-container=".sidemenu-navigation"
            data-bs-html="true"
            title="<span class='light-mode'>Light</span> <span class='dark-mode'>Dark</span> Mode"
          >
            <i class="bx bx-moon"></i>
          </a>
        </li>
        <li class="nav-item dropdown profile-user-dropdown">
          <a
            class="nav-link"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img
              v-if="$store.state.modules.account.user.profile_image != 'non'"
              :src="$store.state.modules.account.user.profile_image"
              class="profile-user rounded-circle"
              v-alt="$store.state.modules.account.user.username"
            />
            <img
              v-else
              :src="
                $store.state.config.frontpoint +
                'storage/default-user-photo.png'
              "
              class="profile-user rounded-circle"
              v-alt="$store.state.modules.account.user.username"
            />
          </a>
          <div class="dropdown-menu">
            <router-link :to="{ name: 'Profile' }" custom v-slot="{ navigate }">
              <a
                role="link"
                @click="navigate"
                class="dropdown-item d-flex align-items-center justify-content-between"
                id="pills-user-tab"
                @keypress.enter="navigate"
              >
                Profile <i class="bx bx-user-circle text-muted ms-1"></i>
              </a>
            </router-link>
            <router-link :to="{ name: 'Setting' }" custom v-slot="{ navigate }">
              <a
                role="link"
                @click="navigate"
                class="dropdown-item d-flex align-items-center justify-content-between"
                id="pills-setting-tab"
                @keypress.enter="navigate"
              >
                Setting <i class="bx bx-cog text-muted ms-1"></i>
              </a>
            </router-link>
            <div
              class="dropdown-item d-flex align-items-center justify-content-between pe-2"
            >
              <span>Google translate</span>
              <div
                id="google_translate_element"
                class="ms-1"
                title="Select Language"
              ></div>
            </div>

            <div class="dropdown-divider"></div>
            <elSignOut />
          </div>
        </li>
      </ul>
    </div>
    <!-- end side-menu nav -->
  </div>
</template>

<script>
import elSignOut from "../../modules/authentication/components/SignOut.vue";
export default {
  name: "SideMenu",

  components: {
    elSignOut,
  },

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {});
  },
  methods: {
    test() {
      document.querySelector(".user-chat").classList.add("user-chat-show");
    },
    initSettings() {
      console.log("initSettings");
      var body = document.getElementsByTagName("body")[0];
      var lightDarkBtn = document.querySelectorAll(".light-dark");
      if (lightDarkBtn) {
        if (
          body.hasAttribute("data-layout-mode") &&
          body.getAttribute("data-layout-mode") == "dark"
        ) {
          document.body.setAttribute("data-layout-mode", "light");
        } else {
          document.body.setAttribute("data-layout-mode", "dark");
        }
      }
    },
  },
};
</script>
